import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex, Text } from '@mantine/core'
import { useState, type MouseEvent } from 'react'

import { type CoreProduct } from '@flecto/types'
import { Icon, PopoverProductBundleItems } from '@flecto/ui'

export type TextBundleQuantityProps = {
  row: CoreProduct
}

export function TextBundleQuantity({ row }: TextBundleQuantityProps) {
  const quantity =
    row.bundle_attributes?.bundle_items?.reduce(
      (sum, item) => sum + (item.quantity ?? 0),
      0
    ) ?? 0

  const [opened, setOpened] = useState(false)

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    setOpened((o) => !o)
  }

  return (
    <PopoverProductBundleItems
      opened={opened}
      onChange={setOpened}
      product={row}
      withStock
      data-testid='popover'
    >
      <Flex align='center'>
        <Text>{quantity}</Text>
        <ActionIcon ml={'-11px'} variant='transparent' onClick={handleClick}>
          <Icon icon={faCircleInfo} />
        </ActionIcon>
      </Flex>
    </PopoverProductBundleItems>
  )
}
